import script from "./SystemOfflinePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemOfflinePage.vue?vue&type=script&setup=true&lang=js"

import "./SystemOfflinePage.vue?vue&type=style&index=0&id=d4b8afae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4b8afae"]])

export default __exports__